import en_US from '../../date-picker/locale/en_US';
export default en_US;


//////////////////
// WEBPACK FOOTER
// ./~/antd/es/calendar/locale/en_US.js
// module id = 654
// module chunks = 0